import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './material-loader.styl'

export default class MaterialLoader extends Component {
  static propTypes = {
    white: PropTypes.bool,
    small: PropTypes.bool,
    tiny: PropTypes.bool
  }

  static defaultProps = {
    white: false,
    small: false,
    tiny: false
  }

  render() {
    const { white, small, tiny } = this.props
    const classNames = [styles.loader]

    white && classNames.push([styles.white])
    small && classNames.push([styles.small])
    tiny && classNames.push([styles.tiny])

    let outerSize = 40
    let innerSize = 20
    let radius = 15

    if (small) {
      outerSize = 24
      innerSize = 12
      radius = 9
    }

    if (tiny) {
      outerSize = 16
      innerSize = 8
      radius = 6
    }

    return (
      <svg
        className={classNames.join(' ')}
        width={outerSize}
        height={outerSize}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx={innerSize} cy={innerSize} r={radius} />
      </svg>
    )
  }
}
